import React, { Component } from "react";
import {
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
} from "@material-ui/core/";
import _, { set } from "lodash";
import { Card, Label, Col, Input, Button, InputGroup, Row } from "reactstrap";
import Fade from "react-reveal/Fade";
import Loader from "../../../Global/Loader";
import axios from "axios";
import { Services } from "../../../../repositories/clients/Services";
import { Icon, TextArea, Checkbox } from "semantic-ui-react";
import { Modal } from "antd";
import TextField from "@mui/material/TextField";
import { withRouter, Link } from "react-router-dom";
import TemplateForms from "./../template";
import ContainerWrapper from "../../../template/Layout/ContentWrapper";
import { ExpandMore, ExpandLess } from "@material-ui/icons";
import { withNamespaces } from "react-i18next";
import { Autocomplete } from "@mui/material";
import { withStyles } from "@material-ui/core/styles";
import Tables from "../../Components/Table";
import TableCheckComponent from "../../Components/TableCheck";
import Swal from "sweetalert2";
import VALIDATION from "../../../../validation";
import CheckboxM from "@mui/material/Checkbox";
import Tooltip from "@mui/material/Tooltip";
import TooltipValidate from "../../PurchaseOrder/info/components/CustomEntities/components/tooltip";
import createModal from "../../Components/ModalV2";
import { openNotification } from "../../Components/Notification";

import "./styles/styles.scss";

const ValidationService = new VALIDATION();

const TRANSPORT_MODE_CATALOG_OPTION = {
  1: "Ocean",
  2: "Air",
  3: "Inland",
  4: "Rail",
};

const useStyles = (theme) => ({
  textfield: {
    "& .MuiInputBase-input.MuiAutocomplete-input": {
      fontSize: 12,
    },
    "& #custom-autocomplete-label": {
      color: "brown",
    },
  },
  root: {
    backgroundColor: "yellow",
  },
  popupIndicator: {
    "& path": {
      d: "path('M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z')",
    },
  },
  popupIndicatorOpen: {
    "& path": {
      d: "path('M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z')",
    },
  },
});

let scrollTableFilter = {
  x: 1200,
  y: 400,
};

let scrollTableFilterPoVisibility = {
  x: 700,
  y: 400,
};

let sistemaDefault = {
  description: "Neurored",
  key: 1,
  text: "Neurored",
  title: "Neurored",
  value: 1,
};

const poFields = [
  "PONumber",
  "LineNo",
  "ItemNo",
  "SupplierName",
  "Description",
  "Status",
  "CustomerName",
  "ConsigneeName",
];

const visibilityFields = [
  "RefCustomer",
  "Status",
  "TransportMode",
  "QTYOrdered",
];
class createUsers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalAlert: false,
      typeAlert: "",
      messageAlert: "",
      buttonCheckValidateActive: true,
      key: 1,
      posPOOriginal: [],
      columnAnt: [
        {
          dataIndex: "PONumber",
          width: 60,
          title: this.props.t("Po_No_Filter"),
          className: "headerTextShipList",
          // fixed: "left",
          render: (value, e) => (
            <Link
              target="_blank"
              to={"/po-detail-view/" + e.POId}
              className="underline-link"
            >
              <span className="linkDetail">{value}</span>
            </Link>
          ),
        },
        {
          dataIndex: "LineNo",
          width: 30,
          title: this.props.t("Line_Filter"),
          className: "headerTextShipList",
          render: (value) => <span className="columTableStyle">{value}</span>,
        },
        {
          dataIndex: "ItemNo",
          width: 30,
          title: this.props.t("Item_Filter"),
          className: "headerTextShipList",
          render: (value) => <span className="columTableStyle">{value}</span>,
        },
        {
          dataIndex: "Description",
          width: 100,
          title: this.props.t("Description_Filter"),
          className: "headerTextShipList",
          render: (value) => {
            if (value) {
              if (value.length > 40) {
                return (
                  <Tooltip
                    title={
                      <span
                        className="label-euro "
                        style={{ marginLeft: "5px", fontWeight: "normal" }}
                      >
                        {value}
                      </span>
                    }
                    placement="bottom"
                  >
                    <span className="columTableStyle">
                      {value.substring(0, 30)}...
                    </span>
                  </Tooltip>
                );
              } else {
                return <span className="columTableStyle">{value}</span>;
              }
            } else {
              return <span className="columTableStyle"></span>;
            }
          },
        },
        {
          dataIndex: "Status",
          width: 70,
          title: this.props.t("Status_Filter"),
          className: "headerTextShipList",
          render: (value) => (
            <span
              className="columTableStyle"
              style={{ color: "#000a2e", fontWeight: "bold" }}
            >
              {value}
            </span>
          ),
        },
        // {
        //   dataIndex: "CustomerName",
        //   width: "20em",
        //   title: this.props.t("Customer_Filter"),
        //   className: "headerTextShipList",
        //   render: (value) => <span className="columTableStyle">{value}</span>,
        // },
        // {
        //   dataIndex: "SupplierName",
        //   width: "20em",
        //   title: this.props.t("Supplier_Filter"),
        //   className: "headerTextShipList",
        //   render: (value, e) => {
        //     const dataTootipSupplier = {
        //       tooltipValue: e.SupplierNameEuro,
        //       tooltipAddress: e.SupplierAddressEuro,
        //     };
        //     return (
        //       <p className="row divcenter">
        //         <span className="columTableStyle">
        //           {value}{" "}
        //           {value && <TooltipValidate entity={dataTootipSupplier} />}
        //         </span>
        //       </p>
        //     );
        //   },
        // },
        // {
        //   dataIndex: "ConsigneeName",
        //   width: "20em",
        //   title: this.props.t("Consignee_Filter"),
        //   className: "headerTextShipList",
        //   render: (value, e) => {
        //     const dataTootipConsigniee = {
        //       tooltipValue: e.ConsigneeNameEuro,
        //       tooltipAddress: e.ConsigneeAddressEuro,
        //     };
        //     return (
        //       <p className="row divcenter">
        //         <span className="columTableStyle">
        //           {value}
        //           {value && <TooltipValidate entity={dataTootipConsigniee} />}
        //         </span>{" "}
        //       </p>
        //     );
        //   },
        // },
        // {
        //   dataIndex: "PONumber",
        //   width: 150,
        //   title: this.props.t("Entrance_To_Filter"),
        //   className: "headerTextShipList",
        //   render: (value) => <span className="columTableStyle">{value}</span>,
        // },
        {
          dataIndex: "QTYOrdered",
          width: 70,
          title: this.props.t("Qty_Ordered_Filter"),
          className: "headerTextShipList",
          rowClassName: "rowTextShipList",
          render: (value) => <span className="columTableStyle">{value}</span>,
        },
        {
          dataIndex: "QTYConfirmed",
          width: 70,
          title: this.props.t("Qty_Confirmed_Filter"),
          className: "headerTextShipList",
          sort: true,
          render: (value) => <span className="columTableStyle">{value}</span>,
        },
      ],
      isMovil: false,
      visible: false,
      data: {},
      value: "",
      TemplateForms,
      createFormsData: [],
      isEdit: false,
      info: {
        TypeOrder: 1,
        osLis: [],
        poPurchaselist: [],
        TrasportMode: "",
        SistemaEp: {
          description: "Neurored",
          key: 1,
          text: "Neurored",
          title: "Neurored",
          value: 1,
        },
        lineCarge: 0,
        totalweights: 0,
        QTYConfirmated: 0,
        OKAM: "",
        DL: "",
        Borders: "",
        Agente: "",
        FreightTermCode: "",
        ServiceLevel: "",
      },
      catalgoSearch: [],
      loadingInfo: true,
      poActive: false,
      columns: [
        {
          title: this.props.t("order_ref"),
          dataIndex: "RefCustomer",
          width: 150,
          render: (value, e) => (
            <Link
              target="_blank"
              to={"/so-detail-view/" + e.ServiceOrderId}
              className="underline-link"
            >
              <span className="linkDetail">{value}</span>
            </Link>
          ),
        },
        {
          title: this.props.t("status"),
          dataIndex: "Status",
          width: 70,
          render: (value) => <span className="columTableStyle">{value}</span>,
        },
        {
          title: this.props.t("qty_ordered"),
          dataIndex: "QTYOrdered",
          width: 100,
          render: (value) => <span className="columTableStyle">{value}</span>,
        },
        {
          title: this.props.t("transport_mode"),
          dataIndex: "TransportMode",
          width: 100,
          render: (value) => <span className="columTableStyle">{value}</span>,
        },
      ],
      columns_OS: [
        {
          label: this.props.t("line"),
          key: "",
          minWidth: 120,
          align: "center",
          index: true,
        },
        {
          label: this.props.t("order_ref"),
          key: "",
          minWidth: 170,
          align: "center",
          fixed: true,
          custom: (value) => (
            <Col md={12} xl={12}>
              <Link
                target="_blank"
                to={"/so-detail-view/" + value.ServiceOrderId}
                className="underline-link"
              >
                <span className="linkDetail">{value.RefCustomer}</span>
              </Link>
            </Col>
          ),
        },
        {
          label: this.props.t("number"),
          key: "OrderNumber",
          minWidth: 190,
          align: "center",
        },
        {
          label: this.props.t("status"),
          key: "Status",
          minWidth: 120,
          align: "center",
        },
        {
          label: this.props.t("shipper"),
          key: "SupplierName",
          minWidth: 120,
          align: "center",
          tooltip: true,
          tpkey1: "SupplierDirection",
          tpkey2: "SupplierCity",
          tpkey3: "SupplierState",
          tpkey4: "SupplierCountry",
        },
        {
          label: this.props.t("consignee"),
          key: "ConsigneeName",
          minWidth: 120,
          align: "center",
          tooltip: true,
          tpkey1: "ConsigneeDirection",
          tpkey2: "ConsigneeCity",
          tpkey3: "ConsigneeState",
          tpkey4: "ConsigneeCountry",
        },
        {
          label: this.props.t("shipment_ready"),
          key: "ActualCargoReadyDate",
          minWidth: 120,
          align: "center",
        },
        {
          label: this.props.t("gross_weight"),
          key: "GrossWeight",
          minWidth: 120,
          align: "center",
          separador: true,
        },
        {
          label: this.props.t("qty_ordered"),
          key: "QTYOrdered",
          minWidth: 120,
          align: "center",
          separador: true,
        },
        {
          label: "Requerido en destino",
          key: "RequiredDateDestination",
          minWidth: 120,
          align: "center",
        },
      ],
      columns_PurchaceOrder: [
        {
          label: this.props.t("Po_No_Filter"),
          key: "PONumber",
          minWidth: 120,
          align: "center",
          custom: (value) => (
            <Col md={12} xl={12}>
              <Link
                target="_blank"
                to={"/po-detail-view/" + value.POId}
                className="underline-link"
              >
                <span className="linkDetail">{value.PONumber}</span>
              </Link>
            </Col>
          ),
        },
        {
          label: this.props.t("line"),
          key: "LineNo",
          minWidth: 120,
          align: "center",
          // index: true,
        },
        {
          label: this.props.t("Item_Filter"),
          key: "ItemNo",
          minWidth: 120,
          align: "center",
          // index: true,
        },
        {
          label: this.props.t("Description_Filter"),
          key: "Description",
          minWidth: 170,
          align: "center",
        },
        {
          label: this.props.t("Status_Filter"),
          key: "Status",
          minWidth: 190,
          align: "center",
        },
        {
          label: this.props.t("Customer_Filter"),
          key: "CustomerName",
          minWidth: 200,
          align: "center",
        },
        {
          label: this.props.t("Supplier_Filter"),
          key: "SupplierName",
          minWidth: 250,
          align: "center",
          custom: (value) => {
            const dataTootipSupplierNameSumary = {
              tooltipValue: value.SupplierNameEuro,
              tooltipAddress: value.SupplierAddressEuro,
            };
            return (
              <p className="row divcenter">
                <span className="columTableStyle">
                  {value.SupplierName}
                  {value.SupplierName && (
                    <TooltipValidate entity={dataTootipSupplierNameSumary} />
                  )}
                </span>{" "}
              </p>
            );
          },
        },
        {
          label: this.props.t("Consignee_Filter"),
          key: "ConsigneeName",
          minWidth: 250,
          align: "center",
          tooltip: true,
          custom: (value) => {
            const dataTootipConsignieeSumary = {
              tooltipValue: value.ConsigneeNameEuro,
              tooltipAddress: value.ConsigneeAddressEuro,
            };
            return (
              <p className="row divcenter">
                <span className="columTableStyle">
                  {value.ConsigneeName}
                  {value.ConsigneeName && (
                    <TooltipValidate entity={dataTootipConsignieeSumary} />
                  )}
                </span>{" "}
              </p>
            );
          },
        },
        {
          label: this.props.t("Entrance_To_Filter"),
          key: "PONumber",
          minWidth: 200,
          align: "center",
        },
        {
          label: this.props.t("Qty_Ordered_Filter"),
          key: "QTYOrdered",
          minWidth: 200,
          align: "center",
        },
        {
          label: this.props.t("Qty_Confirmed_Filter"),
          key: "QTYConfirmed",
          minWidth: 200,
          align: "center",
        },
      ],
      posPO: [],
      poPurchaseOrderADD: [],

      posList: [],
      addConsolPlan: [],

      leftSearch: "",
      rightSearch: "",

      // Transfer LEFT
      leftSelectedKeys: [],
      leftSelectedRows: [],

      // Transfer RIGHT
      rightSelectedKeys: [],
      rightSelectedRows: [],
    };
  }

  componentDidMount = async () => {
    let details = navigator.userAgent;
    let regexp = /android|iphone|kindle|ipad/i;
    let isMobileDevice = regexp.test(details);
    this.setState({
      isMovil: isMobileDevice,
    });

    await this.getCatalogs();
    this.setState({ loadingInfo: false });
  };

  componentWillReceiveProps = (nextProps) => {
    this.setState({
      newSelected: [],
      selectcheck: false,
      Form: nextProps.form,
      reset: true,
    });
  };

  modifyTitle = async (owner, transportModeSelected, catSentby) => {
    let catSentbyCopy = _.cloneDeep(catSentby);
    let nameInstance = "";

    if (owner) {
      const { NeuroredRoad, NeuroredAirOcean, Revenova } = owner;
      if (transportModeSelected !== 3) {
        if (NeuroredAirOcean) {
          nameInstance = NeuroredAirOcean;
          let exits = catSentbyCopy.find((item) => item.key === 1);
          if (exits) {
            for (let i = 0; i < catSentbyCopy.length; i++) {
              // console.log("catSentbyCopy[i].key", catSentbyCopy[i].key);
              if (catSentbyCopy[i].key === 1) {
                catSentbyCopy[i].title =
                  catSentbyCopy[i].title + " - " + NeuroredAirOcean; // no eliminar
                // catSentbyCopy[i].title;
              }
            }
          }
          catSentbyCopy = catSentbyCopy.filter((item) => item.key !== 2); // Eliminar el elemento con key 2 de sistemaEp
        } else {
          catSentbyCopy = catSentbyCopy.filter((item) => item.key !== 1); // Eliminar el elemento con key 1 de sistemaEp
        }
      } else {
        if (NeuroredRoad) {
          nameInstance = NeuroredRoad;
          let exits = catSentbyCopy.find((item) => item.key === 1);
          if (exits) {
            for (let i = 0; i < catSentbyCopy.length; i++) {
              // console.log("catSentbyCopy[i].key", catSentbyCopy[i].key);
              if (catSentbyCopy[i].key === 1) {
                catSentbyCopy[i].title =
                  catSentbyCopy[i].title + " - " + NeuroredRoad; // no eliminar
                // catSentbyCopy[i].title;
              }
            }
          }
        } else {
          catSentbyCopy = catSentbyCopy.filter((item) => item.key !== 1); // Eliminar el elemento con key 1 de sistemaEp
        }
        if (Revenova) {
          nameInstance = Revenova;
          let exits = catSentbyCopy.find((item) => item.key === 2);
          if (exits) {
            for (let i = 0; i < catSentbyCopy.length; i++) {
              if (catSentbyCopy[i].key === 2) {
                catSentbyCopy[i].title =
                  catSentbyCopy[i].title + " - " + Revenova; // no eliminar
                // catSentbyCopy[i].title;
              }
            }
          }
        } else {
          catSentbyCopy = catSentbyCopy.filter((item) => item.key !== 2); // Eliminar el elemento con key 2 de sistemaEp
        }
      }
    }
    return { catSentbyCopy, nameInstance };
  };

  validateOwner = async (ownerName, transportModeSelected) => {
    let { catalgoSearch } = this.state;
    let newcatalgoSearch = _.cloneDeep(catalgoSearch);
    let validateNewCatTransportModes = false;

    let newCatTransportModes = [];
    let newCatDLOKAM = [];
    let catSentby = newcatalgoSearch[0]["SistemaEp"];
    let newcatSentby = [];
    const ownerTeamToFilter = ownerName;
    const filteredOwners = newcatalgoSearch[0]["Owner"].filter(
      (owner) => owner.OwnerTeam === ownerTeamToFilter,
    );

    if (transportModeSelected) {
      let { catSentbyCopy, nameInstance } = await this.modifyTitle(
        filteredOwners[0],
        transportModeSelected,
        _.cloneDeep(catSentby),
      );
      newcatSentby = catSentbyCopy;
      nameInstance = nameInstance;
      newCatDLOKAM = newcatalgoSearch[0]["ExecutiveXPD"];
    }
    validateNewCatTransportModes = true;
    newCatTransportModes = newcatalgoSearch[0]["CatTransportModes"];
    return {
      validateNewCatTransportModes,
      newCatTransportModes,
      newcatSentby,
      newCatDLOKAM,
    };
  };

  getCatalogs = async () => {
    let userId = this.props._user;
    await axios
      .get(`${Services.PLANTRANSPORT.path}plantrasp/catalogs/${userId}`, {})
      .then((response) => {
        let catalgoSearch = [];
        let data = response.data.data;
        let keys = Object.keys(data);
        keys.forEach((key) => {
          if (data[key] && data[key].length > 0) {
            this.sortCatalogs(data[key], "text");
          }
        });
        catalgoSearch.push(data);
        this.setState(
          {
            catalgoSearch,
          },
          () => {
            // this.renderForm();
            this.renderForm(false, [], undefined, [], [], [], [], []);
          },
        );
      })
      .catch((error) => {
        console.warn(error);
      });
  };

  getOrdersTo = async (IdCustomer, codeEP) => {
    let lang = this.props.lng;
    return new Promise(function (resolve, reject) {
      let data = {
        IdCustomer: IdCustomer,
        codeEP: codeEP,
        lang,
      };
      axios
        .post(`${Services.PLANTRANSPORT.path}plantrasp/getorder-to`, data)
        .then((response) => {
          let posList = response.data.data;
          let posPO = response.data.dataPo;
          let posPOOriginal = response.data.dataPo;
          let catAgente = response.data.catAgente;

          for (let i = 0; i < posList.length; i++) {
            const e = posList[i];
            e.hidden = false;
            e.Visible = 1;
            e.checked = false;
          }
          for (let i = 0; i < posPO.length; i++) {
            const e = posPO[i];
            e.hidden = false;
            e.key = e.POItemsId;
            e.Visible = 1;
            e.checked = false;
          }
          resolve({ posList, posPO, posPOOriginal, catAgente });
        })
        .catch((error) => {
          console.warn(error);
        });
    });
  };

  handleChange = (name, value) => async (event) => {
    let { info, catalgoSearch } = this.state;
    let newcatalgoSearch = _.cloneDeep(catalgoSearch);
    let serviceTypeCat = [];
    let InitnewCatDLOKAM = [];
    let initNewCatServiceLevel = [];

    info[name] = event.target.value;
    let transportModeSelected = info["TrasportMode"]
      ? info["TrasportMode"].key
      : undefined;

    let {
      validateNewCatTransportModes,
      newCatTransportModes,
      newcatSentby,
      newCatDLOKAM,
    } = await this.validateOwner(
      info.NameCustomers.OwnerTeam,
      transportModeSelected,
    );
    InitnewCatDLOKAM = newCatDLOKAM;
    let catalogoTrasportModeFinal = validateNewCatTransportModes
      ? newCatTransportModes
      : undefined;

    // console.log("newcatalgoSearch", newcatalgoSearch);

    if (info["TrasportMode"]) {
      let catalogNuevo = [];
      let uniqueCatalog = [];

      if (
        info["TrasportMode"] !== undefined &&
        info["ServiceType"] !== undefined
      ) {
        catalogNuevo = newcatalgoSearch[0]["ServiceTypeList"].filter(
          (e) =>
            e.TransportModeId === info["TrasportMode"].key &&
            e.SystemId === info["SistemaEp"].key &&
            e.ServiceTypeId === info["ServiceType"].key,
        );
        uniqueCatalog = Array.from(
          new Map(catalogNuevo.map((item) => [item.key, item])).values(),
        );
      }
      serviceTypeCat = newcatalgoSearch[0]["CatServiceTypes"].filter(
        (e) =>
          e[info["TrasportMode"].text] === "1" &&
          e.SystemId === info["SistemaEp"].key,
      );

      if (info["ShipmentsType"] && info["ShipmentsType"].key) {
        initNewCatServiceLevel = newcatalgoSearch[0]["ServiceLevel"].filter(
          (e) =>
            e.TransportModeId === info["TrasportMode"].key &&
            e.ServiceTypeId === info["ServiceType"].key &&
            e.CatShipmentTypeId === info["ShipmentsType"].key,
        );
      }

      // console.log("catalogNuevo", catalogNuevo);

      this.setState({ info, buttonCheckValidateActive: true }, () => {
        this.renderForm(
          false,
          uniqueCatalog,
          true,
          serviceTypeCat,
          catalogoTrasportModeFinal,
          newcatSentby,
          InitnewCatDLOKAM,
          initNewCatServiceLevel,
        );
      });
    } else {
      this.setState({ info, buttonCheckValidateActive: true }, () => {
        this.renderForm(
          false,
          [],
          undefined,
          [],
          catalogoTrasportModeFinal,
          newcatSentby,
          InitnewCatDLOKAM,
          initNewCatServiceLevel,
        );
      });
    }
  };

  handleChangeSelect = async (evt, data, id) => {
    let { info, catalgoSearch, TemplateForms } = this.state;

    let newcatalgoSearch = _.cloneDeep(catalgoSearch);
    let newTemplateForms = _.cloneDeep(TemplateForms);
    let serviceTypeCat = [];
    let transportModeSelected = undefined;
    let catalogoTrasportModeFinal = undefined;
    let newcatSentbyFinal = undefined;
    let InitnewCatDLOKAM = [];
    let initNewCatServiceLevel = [];

    if (id === "TrasportMode") {
      transportModeSelected = data ? data.key : undefined;
    } else {
      transportModeSelected = info["TrasportMode"]
        ? info["TrasportMode"].key
        : undefined;
    }
    if (info.NameCustomers && info.NameCustomers.OwnerTeam) {
      let {
        validateNewCatTransportModes,
        newCatTransportModes,
        newcatSentby,
        newCatDLOKAM,
      } = await this.validateOwner(
        info.NameCustomers.OwnerTeam,
        transportModeSelected,
      );
      catalogoTrasportModeFinal = validateNewCatTransportModes
        ? newCatTransportModes
        : undefined;
      newcatSentbyFinal = newcatSentby;
      InitnewCatDLOKAM = newCatDLOKAM;
    } else {
      catalogoTrasportModeFinal = [];
    }

    if (data) {
      let validateCatST = data.text;
      info[id] = data;
      if (id === "TrasportMode") {
        info["ShipmentsType"] = undefined;
        info["ServiceType"] = undefined;
        info["Borders"] = undefined;
        info["Agente"] = undefined;
        info["OKAM"] = undefined;
        info["DL"] = undefined;
        info["SistemaEp"] = newcatSentbyFinal.filter(
          (e) => e.key === 1 || e.key === 2,
        )[0];
        info["FreightTermCode"] = undefined;
        info["ServiceLevel"] = undefined;

        // info["DL"] = undefined;
        // info["OKAM"] = undefined;
        if (data.key === 3) {
          for (let i = 0; i < newTemplateForms[0].create.length; i++) {
            const e = newTemplateForms[0].create[i];
            if (e.id === "SistemaEp") {
              newTemplateForms[0].create[i].hidden = false;
            }
            if (e.id === "Borders") {
              newTemplateForms[0].create[i].view = false;
            }
            if (e.id === "Agente") {
              newTemplateForms[0].create[i].view = false;
            }
            // if (e.id === 'OKAM'){
            //   newTemplateForms[0].create[i].view=true;
            // }
            // if (e.id === 'DL'){
            //   newTemplateForms[0].create[i].view=true;
            // }
          }
        } else {
          for (let i = 0; i < newTemplateForms[0].create.length; i++) {
            const e = newTemplateForms[0].create[i];
            if (e.id === "SistemaEp") {
              newTemplateForms[0].create[i].hidden = true;
            }
            if (e.id === "Borders") {
              newTemplateForms[0].create[i].view = false;
            }
            if (e.id === "Agente") {
              newTemplateForms[0].create[i].view = false;
            }
            // if (e.id === 'OKAM'){
            //   newTemplateForms[0].create[i].view=false;
            // }
            // if (e.id === 'DL'){
            //   newTemplateForms[0].create[i].view=false;
            // }
          }
        }

        for (let i = 0; i < newTemplateForms[0].create.length; i++) {
          const e = newTemplateForms[0].create[i];
          if (e.id === "FreightTermCode") {
            newTemplateForms[0].create[i].selectCatalogName =
              TRANSPORT_MODE_CATALOG_OPTION[data.key];
          }
        }

        serviceTypeCat = newcatalgoSearch[0]["CatServiceTypes"].filter(
          (e) =>
            e[validateCatST] === "1" && e.SystemId === info["SistemaEp"].key,
        );

        this.setState(
          {
            info,
            TemplateForms: newTemplateForms,
            buttonCheckValidateActive: true,
          },
          () => {
            this.renderForm(
              false,
              [],
              undefined,
              serviceTypeCat,
              catalogoTrasportModeFinal,
              newcatSentbyFinal,
              InitnewCatDLOKAM,
              [],
            );
          },
        );
      } else {
        if (id === "ShipmentsType") {
          info["ServiceLevel"] = undefined;
          let catalogNuevo = newcatalgoSearch[0]["ServiceTypeList"].filter(
            (e) =>
              e.TransportModeId === info["TrasportMode"].key &&
              e.SystemId === info["SistemaEp"].key &&
              e.ServiceTypeId === info["ServiceType"].key,
          );

          let uniqueCatalog = Array.from(
            new Map(catalogNuevo.map((item) => [item.key, item])).values(),
          );

          serviceTypeCat = newcatalgoSearch[0]["CatServiceTypes"].filter(
            (e) =>
              e[info["TrasportMode"].text] === "1" &&
              e.SystemId === info["SistemaEp"].key,
          );

          initNewCatServiceLevel = newcatalgoSearch[0]["ServiceLevel"].filter(
            (e) =>
              e.TransportModeId === info["TrasportMode"].key &&
              e.ServiceTypeId === info["ServiceType"].key &&
              e.CatShipmentTypeId === info["ShipmentsType"].key,
          );

          this.setState({ info, buttonCheckValidateActive: true }, () =>
            this.renderForm(
              false,
              uniqueCatalog,
              true,
              serviceTypeCat,
              catalogoTrasportModeFinal,
              newcatSentbyFinal,
              InitnewCatDLOKAM,
              initNewCatServiceLevel,
            ),
          );
        } else if (id === "ServiceType") {
          info["ShipmentsType"] = undefined;
          info["Borders"] = undefined;
          info["Agente"] = undefined;
          info["ServiceLevel"] = undefined;
          if (
            info["TrasportMode"].key === 3 &&
            (data.key === 3 || data.key === 2)
          ) {
            for (let i = 0; i < newTemplateForms[0].create.length; i++) {
              const e = newTemplateForms[0].create[i];
              if (e.id === "Borders") {
                newTemplateForms[0].create[i].view = true;
              }
              if (e.id === "Agente") {
                newTemplateForms[0].create[i].view = true;
              }
            }
          } else {
            for (let i = 0; i < newTemplateForms[0].create.length; i++) {
              const e = newTemplateForms[0].create[i];
              if (e.id === "Borders") {
                newTemplateForms[0].create[i].view = false;
              }
              if (e.id === "Agente") {
                newTemplateForms[0].create[i].view = false;
              }
            }
          }

          let catalogNuevo = newcatalgoSearch[0]["ServiceTypeList"].filter(
            (e) =>
              e.TransportModeId === info["TrasportMode"].key &&
              e.SystemId === info["SistemaEp"].key &&
              e.ServiceTypeId === info["ServiceType"].key,
          );

          let uniqueCatalog = Array.from(
            new Map(catalogNuevo.map((item) => [item.key, item])).values(),
          );

          serviceTypeCat = newcatalgoSearch[0]["CatServiceTypes"].filter(
            (e) =>
              e[info["TrasportMode"].text] === "1" &&
              e.SystemId === info["SistemaEp"].key,
          );

          this.setState(
            {
              info,
              TemplateForms: newTemplateForms,
              buttonCheckValidateActive: true,
            },
            () => {
              this.renderForm(
                false,
                uniqueCatalog,
                true,
                serviceTypeCat,
                catalogoTrasportModeFinal,
                newcatSentbyFinal,
                InitnewCatDLOKAM,
                [],
              );
            },
          );
        } else if (id === "SistemaEp") {
          info["ShipmentsType"] = undefined;
          info["ServiceType"] = undefined;
          info["ServiceLevel"] = undefined;
          // info["SistemaEp"] = sistemaDefault;
          serviceTypeCat = newcatalgoSearch[0]["CatServiceTypes"].filter(
            (e) =>
              e[info["TrasportMode"].text] === "1" && e.SystemId === data.key,
          );
          this.setState({ info, buttonCheckValidateActive: true }, () => {
            this.renderForm(
              false,
              [],
              undefined,
              serviceTypeCat,
              catalogoTrasportModeFinal,
              newcatSentbyFinal,
              InitnewCatDLOKAM,
              [],
            );
          });
        } else {
          let catalogNuevo = [];
          let uniqueCatalog = [];
          if (
            info["TrasportMode"] !== undefined &&
            info["ServiceType"] !== undefined
          ) {
            catalogNuevo = newcatalgoSearch[0]["ServiceTypeList"].filter(
              (e) =>
                e.TransportModeId === info["TrasportMode"].key &&
                e.SystemId === info["SistemaEp"].key &&
                e.ServiceTypeId === info["ServiceType"].key,
            );

            uniqueCatalog = Array.from(
              new Map(catalogNuevo.map((item) => [item.key, item])).values(),
            );
          }
          if (info["TrasportMode"] && info["TrasportMode"].text) {
            serviceTypeCat = newcatalgoSearch[0]["CatServiceTypes"].filter(
              (e) =>
                e[info["TrasportMode"].text] === "1" &&
                e.SystemId === info["SistemaEp"].key,
            );
          } else {
            serviceTypeCat = [];
          }

          if (info["ShipmentsType"] && info["ShipmentsType"].key) {
            initNewCatServiceLevel = newcatalgoSearch[0]["ServiceLevel"].filter(
              (e) =>
                e.TransportModeId === info["TrasportMode"].key &&
                e.ServiceTypeId === info["ServiceType"].key &&
                e.CatShipmentTypeId === info["ShipmentsType"].key,
            );
          }

          this.setState({ info, buttonCheckValidateActive: true }, () =>
            this.renderForm(
              false,
              uniqueCatalog,
              true,
              serviceTypeCat,
              catalogoTrasportModeFinal,
              newcatSentbyFinal,
              InitnewCatDLOKAM,
              initNewCatServiceLevel,
            ),
          );
        }
      }
    } else {
      info[id] = "";
      if (id === "TrasportMode") {
        let catalogNuevo = [];
        let initNewCatServiceLevel = [];
        for (let i = 0; i < newTemplateForms[0].create.length; i++) {
          const e = newTemplateForms[0].create[i];
          if (e.id === "SistemaEp") {
            newTemplateForms[0].create[i].hidden = true;
          }
          if (e.id === "Borders") {
            newTemplateForms[0].create[i].view = false;
          }
          if (e.id === "Agente") {
            newTemplateForms[0].create[i].view = false;
          }
          // if (e.id === 'OKAM'){
          //   newTemplateForms[0].create[i].view=false;
          // }
          // if (e.id === 'DL'){
          //   newTemplateForms[0].create[i].view=false;
          // }
        }
        info["ShipmentsType"] = undefined;
        info["ServiceType"] = undefined;
        info["Borders"] = undefined;
        info["Agente"] = undefined;
        info["FreightTermCode"] = undefined;
        info["DL"] = undefined;
        info["OKAM"] = undefined;
        info["ServiceLevel"] = undefined;

        for (let i = 0; i < newTemplateForms[0].create.length; i++) {
          const e = newTemplateForms[0].create[i];
          if (e.id === "FreightTermCode") {
            newTemplateForms[0].create[i].selectCatalogName = "Freight";
          }
        }
        // info["DL"] = undefined;
        // info["OKAM"] = undefined;
        info["SistemaEp"] = sistemaDefault;
        this.setState(
          {
            info,
            TemplateForms: newTemplateForms,
            buttonCheckValidateActive: true,
          },
          () => {
            this.renderForm(
              false,
              catalogNuevo,
              undefined,
              [],
              catalogoTrasportModeFinal,
              newcatSentbyFinal,
              InitnewCatDLOKAM,
              initNewCatServiceLevel,
            );
          },
        );
      } else {
        if (id === "ShipmentsType") {
          info["ServiceLevel"] = undefined;
          let catalogNuevo = newcatalgoSearch[0]["ServiceTypeList"].filter(
            (e) =>
              e.TransportModeId === info["TrasportMode"].key &&
              e.SystemId === info["SistemaEp"].key &&
              e.ServiceTypeId === info["ServiceType"].key,
          );

          let uniqueCatalog = Array.from(
            new Map(catalogNuevo.map((item) => [item.key, item])).values(),
          );

          serviceTypeCat = newcatalgoSearch[0]["CatServiceTypes"].filter(
            (e) =>
              e[info["TrasportMode"].text] === "1" &&
              e.SystemId === info["SistemaEp"].key,
          );

          this.setState({ info, buttonCheckValidateActive: true }, () =>
            this.renderForm(
              false,
              uniqueCatalog,
              true,
              serviceTypeCat,
              catalogoTrasportModeFinal,
              newcatSentbyFinal,
              InitnewCatDLOKAM,
              initNewCatServiceLevel,
            ),
          );
        } else if (id === "ServiceType") {
          info["ShipmentsType"] = undefined;
          info["Borders"] = undefined;
          info["Agente"] = undefined;
          info["ServiceLevel"] = undefined;

          let catalogNuevo = newcatalgoSearch[0]["ServiceTypeList"].filter(
            (e) =>
              e.TransportModeId === info["TrasportMode"].key &&
              e.SystemId === info["SistemaEp"].key &&
              e.ServiceTypeId === info["ServiceType"].key,
          );

          let uniqueCatalog = Array.from(
            new Map(catalogNuevo.map((item) => [item.key, item])).values(),
          );

          serviceTypeCat = newcatalgoSearch[0]["CatServiceTypes"].filter(
            (e) =>
              e[info["TrasportMode"].text] === "1" &&
              e.SystemId === info["SistemaEp"].key,
          );

          for (let i = 0; i < newTemplateForms[0].create.length; i++) {
            const e = newTemplateForms[0].create[i];
            if (e.id === "Borders") {
              newTemplateForms[0].create[i].view = false;
            }
            if (e.id === "Agente") {
              newTemplateForms[0].create[i].view = false;
            }
          }
          this.setState(
            {
              info,
              TemplateForms: newTemplateForms,
              buttonCheckValidateActive: true,
            },
            () =>
              this.renderForm(
                false,
                uniqueCatalog,
                true,
                serviceTypeCat,
                catalogoTrasportModeFinal,
                newcatSentbyFinal,
                InitnewCatDLOKAM,
                initNewCatServiceLevel,
              ),
          );
        } else {
          let catalogNuevo = [];
          let initNewCatServiceLevel = [];
          let uniqueCatalog = [];

          if (
            info["TrasportMode"] !== undefined &&
            info["ServiceType"] !== undefined
          ) {
            catalogNuevo = newcatalgoSearch[0]["ServiceTypeList"].filter(
              (e) =>
                e.TransportModeId === info["TrasportMode"].key &&
                e.SystemId === info["SistemaEp"].key &&
                e.ServiceTypeId === info["ServiceType"].key,
            );
            uniqueCatalog = Array.from(
              new Map(catalogNuevo.map((item) => [item.key, item])).values(),
            );
          }

          if (info["TrasportMode"] && info["TrasportMode"].text) {
            serviceTypeCat = newcatalgoSearch[0]["CatServiceTypes"].filter(
              (e) =>
                e[info["TrasportMode"].text] === "1" &&
                e.SystemId === info["SistemaEp"].key,
            );
          } else {
            serviceTypeCat = [];
          }

          if (info["ShipmentsType"] && info["ShipmentsType"].key) {
            initNewCatServiceLevel = newcatalgoSearch[0]["ServiceLevel"].filter(
              (e) =>
                e.TransportModeId === info["TrasportMode"].key && // Corregido el error tipográfico
                e.ServiceTypeId === info["ServiceType"].key &&
                e.CatShipmentTypeId === info["ShipmentsType"].key,
            );
          }

          this.setState({ info, buttonCheckValidateActive: true }, () =>
            this.renderForm(
              false,
              uniqueCatalog,
              true,
              serviceTypeCat,
              catalogoTrasportModeFinal,
              newcatSentbyFinal,
              InitnewCatDLOKAM,
              initNewCatServiceLevel,
            ),
          );
        }
      }
    }
  };

  sortCatalogs = (array, attr) => {
    try {
      array.sort((a, b) => {
        const valueA = a[attr];
        const valueB = b[attr];
        if (valueA === undefined || valueB === undefined) {
          return 0;
        }
        return valueA.localeCompare(valueB);
      });

      return array;
    } catch (e) {
      //console.log(e);
      return array;
    }
  };

  handleChangeSearch = async (evt, data, id) => {
    let { info, catalgoSearch } = this.state;
    let newcatalgoSearch = _.cloneDeep(catalgoSearch);
    let newTemplateForms = _.cloneDeep(TemplateForms);
    let InitnewCatDLOKAM = [];

    document.getElementById("loader").style.display = "none";
    document.getElementById("loaderActive").style.display = "block";
    if (data) {
      info["Agente"] = undefined;
      info[""] = undefined;
      info["ShipmentsType"] = undefined;
      info["ServiceType"] = undefined;
      info["Borders"] = undefined;
      info["SistemaEp"] = sistemaDefault;
      info["FreightTermCode"] = undefined;
      info["TrasportMode"] = undefined;
      info["OKAM"] = undefined;
      info["DL"] = undefined;
      info["ServiceLevel"] = undefined;

      for (let i = 0; i < newTemplateForms[0].create.length; i++) {
        const e = newTemplateForms[0].create[i];
        if (e.id === "FreightTermCode") {
          newTemplateForms[0].create[i].selectCatalogName = "Freight";
        }
      }

      let IdCustomer = data.key;
      let codeEP = data.codeEp;
      info[id] = data;
      let { posList, posPO, catAgente, posPOOriginal } = await this.getOrdersTo(
        IdCustomer,
        codeEP,
      );

      info["osLis"] = [];
      info["poPurchaselist"] = [];
      let newCatTransportModes = [];
      let validateNewCatTransportModes = false;
      let newcatSentby = undefined;

      let validateOwner = await this.validateOwner(data.OwnerTeam);
      validateNewCatTransportModes = validateOwner.validateNewCatTransportModes;
      newCatTransportModes = validateOwner.newCatTransportModes;
      newcatSentby = validateOwner.newcatSentby;
      InitnewCatDLOKAM = validateOwner.newCatDLOKAM;

      catalgoSearch[0].CatAgente = this.sortCatalogs(catAgente, "text");

      this.setState(
        {
          info,
          posList: posList,
          addConsolPlan: [],
          posPO,
          posPOOriginal,
          poPurchaseOrderADD: [],
          poPurchaseOrderList: [],
          key: Math.random(),
          buttonCheckValidateActive: true,
          TemplateForms: newTemplateForms,
        },
        () => {
          // this.renderForm(false, catalogNuevo, true, serviceTypeCat);
          this.renderForm(
            false,
            [],
            undefined,
            [],
            validateNewCatTransportModes ? newCatTransportModes : undefined,
            newcatSentby,
            InitnewCatDLOKAM,
            [],
          );
        },
      );
    } else {
      info[id] = "";
      info["osLis"] = [];
      info["poPurchaselist"] = [];
      info["Agente"] = undefined;
      catalgoSearch[0].CatAgente = [];

      info["ShipmentsType"] = undefined;

      info["ServiceType"] = undefined;
      info["Borders"] = undefined;
      info["SistemaEp"] = sistemaDefault;
      info["FreightTermCode"] = undefined;
      info["TrasportMode"] = undefined;
      info["OKAM"] = undefined;
      info["DL"] = undefined;
      info["ServiceLevel"] = undefined;

      for (let i = 0; i < newTemplateForms[0].create.length; i++) {
        const e = newTemplateForms[0].create[i];
        if (e.id === "FreightTermCode") {
          newTemplateForms[0].create[i].selectCatalogName = "Freight";
        }
      }

      this.setState(
        {
          info,
          posList: [],
          addConsolPlan: [],
          posPO: [],
          posPOOriginal: [],
          poPurchaseOrderADD: [],
          poPurchaseOrderList: [],
          key: Math.random(),
          buttonCheckValidateActive: true,
          TemplateForms: newTemplateForms,
        },
        () => {
          let catalogNuevo = [];
          let serviceTypeCat = [];

          this.renderForm(false, undefined, true, [], [], [], [], []);
        },
      );
    }
    document.getElementById("loader").style.display = "block";
    document.getElementById("loaderActive").style.display = "none";
  };

  /*
    ####################################GENERACION DE CAMPOS####################################
   */
  findInCatalog = (info, id, catalogName) => {
    let { catalgoSearch } = this.state;
    let value = {};
    value = catalgoSearch[0][catalogName]
      ? catalgoSearch[0][catalogName].find((catalog) => {
          return info[id] == catalog.value;
        })
      : undefined;
    return value;
  };

  renderForm = (
    isEdit,
    catalogNuevo,
    flat,
    serviceTypeCat,
    newCatTransportModes,
    newcatSentby,
    InitnewCatDLOKAM,
    initNewCatServiceLevel,
  ) => {
    let {
      TemplateForms,
      info,
      poActive,
      columns_OS,
      showCatalogModal,
      createFormsData,
      catalgoSearch,
      columns_PurchaceOrder,
    } = this.state;
    createFormsData = [];
    const { classes } = this.props;
    TemplateForms.map((TemplateForm) => {
      createFormsData.push({
        img: TemplateForm.img,
        id: TemplateForm.id,
        expanded: true,
        titulo: TemplateForm.titulo,
        form: TemplateForm[isEdit ? "edit" : "create"].map((e) => {
          // console.log("e.id", e.id);
          if (e.type === "Input") {
            return (
              <div style={{ marginTop: "15px" }} className={e.class} key={e.id}>
                <Fade left opposite>
                  {" "}
                  <span id={e.id} style={e.style}>
                    <label className="labelBody">
                      {this.props.t(e.label)}{" "}
                      {e.required === true ? (
                        <span style={{ color: "#ff0000" }}>*</span>
                      ) : (
                        ""
                      )}
                    </label>
                  </span>
                </Fade>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Input
                    required
                    onFocus={(e) => {
                      e.target.setAttribute("autocomplete", "none");
                    }}
                    type={e.datatype}
                    placeholder={this.props.t(e.placeHolder)}
                    name={e.id}
                    value={info[e.id]}
                    disabled={e.disabled}
                    className={e.id === "Email" ? "email-lower" : ""}
                    autoComplete="new-password"
                    onChange={this.handleChange(e.id, isEdit ? true : false)}
                    max={e.max}
                  />
                </div>
              </div>
            );
          } else if (e.type === "Label") {
            return (
              <div style={{ marginTop: "15px" }} className={e.class} key={e.id}>
                <Fade left opposite>
                  {" "}
                  <span id={e.id} style={e.style}>
                    <label
                      className="labelBody"
                      style={{
                        color: "#000a2e",
                        marginBottom: "1em",
                        fontWeight: "bold",
                      }}
                    >
                      {this.props.t(e.label)}{" "}
                    </label>
                  </span>
                </Fade>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "2em",
                  }}
                >
                  <span id={e.id} style={e.style}>
                    <label>
                      {e.check
                        ? e.selectCatalogName[0].label
                        : typeof info[e.id] === "object"
                          ? info[e.id] === null || info[e.id] === undefined
                            ? ""
                            : info[e.id].text
                          : e.separador
                            ? Number(info[e.id]).toLocaleString("En-us")
                            : info[e.id]}
                    </label>
                  </span>
                </div>
              </div>
            );
          } else if (e.type === "SelectSearch") {
            let autocompleteValue = this.findInCatalog(
              info,
              e.id,
              e.selectCatalogName,
            );
            return (
              <div style={{ marginTop: "15px" }} className={e.class} key={e.id}>
                <Fade left opposite>
                  {" "}
                  <span id={e.id} style={e.style}>
                    <label
                      style={{
                        color: e.error && e.error != "" ? "#f00" : "#000a2e",
                        fontWeight: "bold",
                        marginBottom: "15px",
                      }}
                    >
                      {this.props.t(e.label)}
                      {e.required === true ? (
                        <span style={{ color: "#ff0000" }}>*</span>
                      ) : (
                        ""
                      )}
                    </label>
                  </span>
                </Fade>
                <div style={{ alignItems: "center" }}>
                  <Autocomplete
                    closeText={false}
                    openText={false}
                    noOptionsText={this.props.t("no_options")}
                    style={{ marginTop: "6px" }}
                    id="size-small-standard"
                    className="input-euro"
                    size="small"
                    ListboxProps={{
                      sx: { fontSize: 12 },
                    }}
                    sx={{
                      "& .MuiAutocomplete-input, & .MuiInputLabel-root": {
                        fontSize: 12,
                      },
                    }}
                    options={
                      catalgoSearch[0][e.selectCatalogName]
                        ? catalgoSearch[0][e.selectCatalogName]
                        : []
                    }
                    getOptionLabel={(option) => option.text}
                    renderOption={(props, option, value) => {
                      props.key = option.key;
                      return (
                        <div {...props}>
                          {option.subText && option.subText != "" ? (
                            <div className="row">
                              <div className="col-12">{option.text}</div>
                              <div className="col-12">
                                <label style={{ opacity: ".5" }}>
                                  {option.subText}
                                </label>{" "}
                              </div>
                            </div>
                          ) : (
                            <span>{option.text}</span>
                          )}
                        </div>
                      );
                    }}
                    filterOptions={(options, event) => {
                      let filteredOptions = options.filter((opt) => {
                        return (
                          event.inputValue == "" ||
                          opt.text
                            .toLowerCase()
                            .includes(event.inputValue.toLowerCase())
                        );
                      });
                      return filteredOptions;
                    }}
                    onChange={(evt, data) => {
                      this.handleChangeSearch(evt, data, e.id);
                    }}
                    classes={
                      e.id == "CustomerId"
                        ? {
                            clearIndicatorDirty: classes.clearIndicator,
                            popupIndicator: classes.popupIndicator,
                            popupIndicatorOpen: classes.popupIndicatorOpen,
                          }
                        : false
                    }
                    isOptionEqualToValue={(option, value) => {
                      return option.value == value.value;
                    }}
                    value={autocompleteValue}
                    renderInput={(params) => {
                      params.inputProps.value =
                        autocompleteValue && autocompleteValue.text
                          ? autocompleteValue.text
                          : params.inputProps.value;
                      return (
                        <TextField
                          {...params}
                          variant="standard"
                          className={classes.textfield}
                        />
                      );
                    }}
                  />
                </div>
              </div>
            );
          } else if (e.type === "TextArea") {
            return (
              <div style={{ marginTop: "15px" }} className={e.class} key={e.id}>
                <Fade left opposite>
                  {" "}
                  <span id={e.id} style={e.style}>
                    <label
                      className="labelBody"
                      style={{
                        color: "#000a2e",
                        fontWeight: "bold",
                      }}
                    >
                      {this.props.t(e.label)}
                      {e.required === true ? (
                        <span style={{ color: "#ff0000" }}>*</span>
                      ) : (
                        ""
                      )}
                    </label>
                  </span>
                </Fade>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <TextArea
                    required={e.required}
                    onFocus={(e) => {
                      e.target.setAttribute("autocomplete", "none");
                    }}
                    type={e.datatype}
                    placeholder={this.props.t(e.placeHolder)}
                    name={e.id}
                    value={info[e.id]}
                    className="custom-textarea"
                    style={{
                      width: "100%",
                      color: "#323C47",
                      fontSize: "12px",
                    }}
                    onChange={this.handleChange(e.id, info[e.id])}
                  />
                </div>
              </div>
            );
          } else if (e.type === "LabelRef") {
            return (
              <div style={{ marginTop: "15px" }} className={e.class} key={e.id}>
                <Fade left opposite>
                  {" "}
                  <span id={e.id} style={e.style}>
                    <label className="labelBody">
                      {this.props.t(e.label)}
                      {e.required === true ? (
                        <span style={{ color: "#ff0000" }}>*</span>
                      ) : (
                        ""
                      )}
                    </label>
                  </span>
                </Fade>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Label className="labelBody" value={info[e.id]} />
                </div>
              </div>
            );
          } else if (e.type === "CheckboxCicule") {
            return (
              <div style={{ marginTop: "15px" }} className={e.class} key={e.id}>
                <Fade left opposite>
                  {" "}
                  <span id={e.id} style={e.style}>
                    <label
                      className="labelBody"
                      style={{
                        color: "#000a2e",
                        fontWeight: "bold",
                        marginBottom: "1em",
                      }}
                    >
                      {this.props.t(e.label)}
                      {e.required === true ? (
                        <span
                          className="labelBody"
                          style={{ color: "#ff0000" }}
                        >
                          *
                        </span>
                      ) : (
                        ""
                      )}
                    </label>
                  </span>
                </Fade>
                <div className="row" style={{ alignItems: "center" }}>
                  {e.selectCatalogName.map((w, index) => {
                    return (
                      <div
                        className=" labelBody col-md-6"
                        style={{ alignItems: "center", color: "#000a2e" }}
                      >
                        <Checkbox
                          radio
                          className="labelBody"
                          disabled={w.disabled}
                          style={{ color: "#000a2e" }}
                          // label={this.props.t(w.label)}
                          label={
                            <label>
                              <span className="labelBody">
                                {this.props.t(w.label)}
                              </span>
                            </label>
                          }
                          // style={{ fontSize: "12px !important" }}
                          name={"checkbox-23"}
                          checked={w.id === info[e.id] ? info[e.id] : false}
                          onChange={(e, data) => {
                            let info = this.state.info;
                            info["TypeOrder"] = w.id;

                            if (!poActive) {
                              info.lineCarge = info.poPurchaselist.length;
                              info.totalweights = 0;
                              info.QTYConfirmated = 0;
                              info.poPurchaselist.forEach((e, index) => {
                                info.QTYConfirmated =
                                  info.QTYConfirmated + Number(e.QTYOrdered);
                                info.totalweights =
                                  info.totalweights + Number(e.GrossWeight);
                              });
                            } else {
                              info.lineCarge = info.osLis.length;
                              info.totalweights = 0;
                              info.QTYConfirmated = 0;
                              info.osLis.forEach((e, index) => {
                                info.QTYConfirmated =
                                  info.QTYConfirmated + Number(e.QTYOrdered);
                                info.totalweights =
                                  info.totalweights + Number(e.GrossWeight);
                              });
                            }

                            this.setState(
                              {
                                info,
                                value: w.id,
                                poActive: !poActive,
                                buttonCheckValidateActive: true,
                              },
                              () => {
                                this.renderForm(
                                  false,
                                  [],
                                  undefined,
                                  [],
                                  newCatTransportModes,
                                  newcatSentby,
                                  InitnewCatDLOKAM,
                                  initNewCatServiceLevel,
                                );
                              },
                            );
                          }}
                        />
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          } else if (e.type === "Bottom") {
            return (
              <div style={{ marginTop: "15px" }} className={e.class} key={e.id}>
                <div className="float-right">
                  <Button
                    color="primary"
                    className="d-flex align-items-center"
                    title={this.props.t("create_new")}
                    onClick={() => {
                      let poActive = info["TypeOrder"] === 2;

                      if (poActive) {
                        this.setState((prev) => ({
                          buttonCheckValidateActive: true,
                          visible: true,
                          poActive,
                          initialLeftData: [...prev.posPO],
                          initialRightData: [...prev.poPurchaseOrderADD],
                        }));
                      } else {
                        this.setState((prev) => ({
                          buttonCheckValidateActive: true,
                          visible: true,
                          poActive,
                          initialLeftData: [...prev.posList],
                          initialRightData: [...prev.addConsolPlan],
                        }));
                      }
                    }}
                  >
                    <span className="icon-plus icon-button-add" />
                    {this.props.t(e.labelBottom)}
                  </Button>
                </div>
              </div>
            );
          } else if (e.type === "Table") {
            return (
              <div className={e.class} key={e.id}>
                {poActive ? (
                  info.poPurchaselist.length > 0 ? (
                    <Tables
                      data={info.poPurchaselist ? info.poPurchaselist : []}
                      columns={columns_PurchaceOrder}
                      options={{}}
                    ></Tables>
                  ) : (
                    ""
                  )
                ) : info.osLis.length > 0 ? (
                  <Tables
                    data={info.osLis ? info.osLis : []}
                    columns={columns_OS}
                    options={{}}
                  ></Tables>
                ) : (
                  ""
                )}
              </div>
            );
          } else if (e.type === "Select") {
            let valueShipmTyp = info[e.id];

            // if (e.id === "SistemaEp") {
            //   if(info[e.id] && info[e.id].title){
            //     info[e.id].title = info[e.id].title + " - " + 'hola';
            //   }
            // }

            if (e.id === "ShipmentsType" && catalogNuevo && !flat) {
              valueShipmTyp = null;
            }

            if (e.view) {
              return (
                <div
                  style={{ marginTop: "15px" }}
                  className={e.class}
                  key={e.id}
                >
                  <Fade left opposite>
                    <span id={e.id} style={e.style}>
                      {" "}
                      <label
                        className="labelBody"
                        style={{
                          color: e.error && e.error != "" ? "#f00" : "#000a2e",
                          fontWeight: "bold",
                          marginBottom: "1em",
                        }}
                      >
                        {this.props.t(e.label)}
                        {e.required ? (
                          <span style={{ color: "#ff0000" }}>*</span>
                        ) : (
                          ""
                        )}{" "}
                      </label>
                    </span>
                  </Fade>
                  <Autocomplete
                    closeText={false}
                    openText={false}
                    disableClearable={
                      e.disableClearable ? e.disableClearable : false
                    }
                    id={e.id2}
                    ListboxProps={{
                      sx: { fontSize: 12 },
                    }}
                    noOptionsText={
                      e.id === "OKAM" || e.id === "DL"
                        ? ""
                        : this.props.t("no_options")
                    }
                    sx={{
                      "& .MuiAutocomplete-input, & .MuiInputLabel-root": {
                        fontSize: 12,
                      },
                    }}
                    options={
                      e.id === "ShipmentsType" && catalogNuevo
                        ? catalogNuevo
                        : (e.id === "ShipmentsType" ||
                              e.id === "ServiceType") &&
                            (!info["TrasportMode"] ||
                              info["TrasportMode"] === "")
                          ? []
                          : e.id === "ServiceType" && serviceTypeCat
                            ? serviceTypeCat
                            : e.id === "TrasportMode" && newCatTransportModes
                              ? newCatTransportModes
                              : e.id === "SistemaEp" && newcatSentby
                                ? newcatSentby
                                : e.id === "DL" || e.id === "OKAM"
                                  ? InitnewCatDLOKAM
                                    ? InitnewCatDLOKAM
                                    : []
                                  : e.id === "ServiceLevel" &&
                                      initNewCatServiceLevel
                                    ? initNewCatServiceLevel
                                    : catalgoSearch[0][e.selectCatalogName]
                    }
                    getOptionLabel={(option) => option.title}
                    onChange={(evt, data) => {
                      this.handleChangeSelect(evt, data, e.id);
                    }}
                    filterOptions={(options, event) => {
                      let filteredOptions = options.filter((opt) => {
                        return (
                          event.inputValue == "" ||
                          opt.title
                            .toLowerCase()
                            .includes(event.inputValue.toLowerCase())
                        );
                      });
                      if (e.id === "OKAM" || e.id === "DL") {
                        if (event.inputValue.length > 2) {
                          return filteredOptions;
                        } else {
                          return [];
                        }
                      } else {
                        return filteredOptions;
                      }
                    }}
                    disabled={
                      e.hidden
                        ? e.hidden
                        : e.id === "SistemaEp"
                          ? newcatSentby.length === 1
                            ? true
                            : false
                          : false
                    }
                    value={valueShipmTyp ? valueShipmTyp : null}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="standard"
                        className={classes.textfield}
                      />
                    )}
                  />
                </div>
              );
            }
          } else {
            return (
              <div
                className={e.class}
                style={{ marginTop: "20px" }}
                key={e.id}
              ></div>
            );
          }
        }),
      });
    });
    this.setState({
      createFormsData,
      showCatalogModal,
      info,
      isEdit,
    });
  };

  handleSave = async () => {
    let { addConsolPlan, catalgoSearch, info } = this.state;
    let newcatalgoSearch = _.cloneDeep(catalgoSearch);
    let InitnewCatDLOKAM = [];
    let initNewCatServiceLevel = [];

    if (info["NameCustomers"] === undefined) {
      this.cancelModal();
    } else {
      info.osLis = [...addConsolPlan];

      info.lineCarge = addConsolPlan.length;
      info.totalweights = 0;
      info.QTYConfirmated = 0;

      addConsolPlan.forEach((e, index) => {
        info.QTYConfirmated = info.QTYConfirmated + Number(e.QTYOrdered);
        info.totalweights = info.totalweights + Number(e.GrossWeight);
      });
      let transportModeSelected = info["TrasportMode"]
        ? info["TrasportMode"].key
        : undefined;

      let {
        validateNewCatTransportModes,
        newCatTransportModes,
        newcatSentby,
        newCatDLOKAM,
      } = await this.validateOwner(
        info.NameCustomers.OwnerTeam,
        transportModeSelected,
      );
      InitnewCatDLOKAM = newCatDLOKAM;
      let catalogoTrasportModeFinal = validateNewCatTransportModes
        ? newCatTransportModes
        : undefined;

      if (info["TrasportMode"]) {
        //console.log("info", info);
        let catalogNuevo = [];
        let uniqueCatalog = [];

        if (
          info["TrasportMode"] !== undefined &&
          info["ServiceType"] !== undefined
        ) {
          catalogNuevo = newcatalgoSearch[0]["ServiceTypeList"].filter(
            (e) =>
              e.TransportModeId === info["TrasportMode"].key &&
              e.SystemId === info["SistemaEp"].key &&
              e.ServiceTypeId === info["ServiceType"].key,
          );

          uniqueCatalog = Array.from(
            new Map(catalogNuevo.map((item) => [item.key, item])).values(),
          );
        }

        let serviceTypeCat = newcatalgoSearch[0]["CatServiceTypes"].filter(
          (e) =>
            e[info["TrasportMode"].text] === "1" &&
            e.SystemId === info["SistemaEp"].key,
        );

        if (info["ShipmentsType"] && info["ShipmentsType"].key) {
          initNewCatServiceLevel = newcatalgoSearch[0]["ServiceLevel"].filter(
            (e) =>
              e.TransportModeId === info["TrasportMode"].key &&
              e.ServiceTypeId === info["ServiceType"].key &&
              e.CatShipmentTypeId === info["ShipmentsType"].key,
          );
        }

        this.setState(
          {
            info,
            visible: false,
          },
          () => {
            openNotification("success", this.props.t("correctly_updated"));
            this.renderForm(
              false,
              uniqueCatalog,
              true,
              serviceTypeCat,
              catalogoTrasportModeFinal,
              newcatSentby,
              InitnewCatDLOKAM,
              initNewCatServiceLevel,
            );
          },
        );
      } else {
        //console.log("info else", info);

        if (
          typeof info["NameCustomers"] !== "undefined" &&
          typeof info["NameCustomers"] === "object"
        ) {
          //console.log("info if 2", info);

          let {
            validateNewCatTransportModes,
            newCatTransportModes,
            newcatSentby,
            newCatDLOKAM,
          } = await this.validateOwner(
            info.NameCustomers.OwnerTeam,
            transportModeSelected,
          );
          InitnewCatDLOKAM = newCatDLOKAM;
          let catalogoTrasportModeFinal = validateNewCatTransportModes
            ? newCatTransportModes
            : undefined;
          this.setState(
            {
              info,
              visible: false,
            },
            () => {
              openNotification("success", this.props.t("correctly_updated"));
              this.renderForm(
                false,
                [],
                undefined,
                [],
                catalogoTrasportModeFinal,
                newcatSentby,
                InitnewCatDLOKAM,
                initNewCatServiceLevel,
              );
            },
          );
        } else {
          this.setState(
            {
              info,
              visible: false,
            },
            () => {
              openNotification("success", this.props.t("correctly_updated"));
              this.renderForm(
                false,
                [],
                undefined,
                [],
                [],
                [],
                InitnewCatDLOKAM,
                [],
              );
            },
          );
        }
      }
    }
  };

  cancelModal = () => {
    const { poActive, initialLeftData, initialRightData } = this.state;

    if (poActive) {
      this.setState({
        posPO: initialLeftData,
        poPurchaseOrderADD: initialRightData,
      });
    } else {
      this.setState({
        posList: initialLeftData,
        addConsolPlan: initialRightData,
      });
    }

    this.setState({
      leftSelectedKeys: [],
      leftSelectedRows: [],
      rightSelectedKeys: [],
      rightSelectedRows: [],
      visible: false,
      leftSearch: "",
      rightSearch: "",
    });
  };

  validateTransPlan = async (status) => {
    let { info, TemplateForms, catalgoSearch } = this.state;
    let newcatalgoSearch = _.cloneDeep(catalgoSearch);
    let transportModeSelected = info["TrasportMode"]
      ? info["TrasportMode"].key
      : undefined;
    let catalogoTrasportModeFinal = undefined;
    let newcatSentbyFinal = undefined;
    let InitnewCatDLOKAM = [];
    let initNewCatServiceLevel = [];

    if (info.NameCustomers && info.NameCustomers.OwnerTeam) {
      let {
        validateNewCatTransportModes,
        newCatTransportModes,
        newcatSentby,
        newCatDLOKAM,
      } = await this.validateOwner(
        info.NameCustomers.OwnerTeam,
        transportModeSelected,
      );
      InitnewCatDLOKAM = newCatDLOKAM;
      catalogoTrasportModeFinal = validateNewCatTransportModes
        ? newCatTransportModes
        : undefined;
      newcatSentbyFinal = newcatSentby;
    } else {
      catalogoTrasportModeFinal = [];
    }

    let BODY = {
      headerDetails: info,
    };
    ValidationService.validate({
      target: "TRANSPLAN-CREATE",
      data: BODY,
      t: this.props.t,
    })
      .then(() => {
        TemplateForms[0].create.map((e) => {
          e.style = { color: "#000000de" };
          e.error = "";
        });
        this.setState(
          { TemplateForms, buttonCheckValidateActive: false },
          () => {
            if (status !== 1) {
              if (info.TypeOrder === 2) {
                if (info.poPurchaselist.length > 0) {
                  this.saveInfoPt(status);
                } else {
                  var element = document.getElementById("inOrdenes");
                  element.style.color = "#ff0000";
                  element.scrollIntoView({
                    block: "center",
                    behavior: "smooth",
                  });
                  openNotification(
                    "error",
                    this.props.t("add_at_least_one_p_order"),
                  );
                  setTimeout(() => {
                    this.setState({ buttonCheckValidateActive: true });
                  }, 2500);
                }
              } else {
                if (info.osLis.length > 0) {
                  this.saveInfoPt(status);
                } else {
                  var element = document.getElementById("inOrdenes");
                  element.style.color = "#ff0000";
                  element.scrollIntoView({
                    block: "center",
                    behavior: "smooth",
                  });

                  openNotification(
                    "error",
                    this.props.t("add_at_least_one_s_order"),
                  );
                  setTimeout(() => {
                    this.setState({ buttonCheckValidateActive: true });
                  }, 2000);
                }
              }
            } else {
              this.saveInfoPt(status);
            }
          },
        );
      })
      .catch((errors) => {
        // console.log("errors", errors);
        let Element = document.getElementById(Object.keys(errors)[0]);
        if (Element) {
          Element.scrollIntoView({ block: "end", behavior: "smooth" });
          Element.focus();
        }
        TemplateForms[0].create.map((e, i) => {
          if (errors[e.id]) {
            e.style = { color: "#e57373" };
            e.error = errors[e.id].label;
          } else {
            e.error = "";
            e.style = { color: "#616161" };
          }
        });
        this.setState(
          { TemplateForms, buttonCheckValidateActive: false },
          () => {
            openNotification(
              "error",
              this.props.t("add_all_mandatory_fields") + ".",
            );
            let catalogNuevo = [];
            let serviceTypeCat = [];
            if (info["TrasportMode"]) {
              let catalogNuevo = [];
              let uniqueCatalog = [];

              if (
                info["TrasportMode"] !== undefined &&
                info["ServiceType"] !== undefined
              ) {
                catalogNuevo = newcatalgoSearch[0]["ServiceTypeList"].filter(
                  (e) =>
                    e.TransportModeId === info["TrasportMode"].key &&
                    e.SystemId === info["SistemaEp"].key &&
                    e.ServiceTypeId === info["ServiceType"].key,
                );

                uniqueCatalog = Array.from(
                  new Map(
                    catalogNuevo.map((item) => [item.key, item]),
                  ).values(),
                );
              }

              if (info["ShipmentsType"] && info["ShipmentsType"].key) {
                initNewCatServiceLevel = newcatalgoSearch[0][
                  "ServiceLevel"
                ].filter(
                  (e) =>
                    e.TransportModeId === info["TrasportMode"].key &&
                    e.ServiceTypeId === info["ServiceType"].key &&
                    e.CatShipmentTypeId === info["ShipmentsType"].key,
                );
              }

              serviceTypeCat = newcatalgoSearch[0]["CatServiceTypes"].filter(
                (e) =>
                  e[info["TrasportMode"].text] === "1" &&
                  e.SystemId === info["SistemaEp"].key,
              );
              this.renderForm(
                false,
                uniqueCatalog,
                true,
                serviceTypeCat,
                catalogoTrasportModeFinal,
                newcatSentbyFinal,
                InitnewCatDLOKAM,
                initNewCatServiceLevel,
              );
            } else {
              this.renderForm(
                false,
                [],
                undefined,
                [],
                [],
                [],
                InitnewCatDLOKAM,
                [],
              );
            }
          },
        );
      });
  };

  saveInfoPt = async (status) => {
    // console.log("status", status);
    let { info } = this.state;
    // console.log("info", info);

    this.setState({ loadingInfo: true });

    let data = {
      statusId: status,
      TransportModeId: info.TrasportMode.key,
      TypesServiceId: info.ServiceType.key,
      ShipmentTypeId: info.ShipmentsType.key,
      SystemId: info.SistemaEp.key,
      IncotermCode: info.Incoterm.key,
      CustomerId: info.NameCustomers.key,
      Borders:
        info.Borders === undefined || info.Borders === ""
          ? null
          : info.Borders.key,
      Agente:
        info.Agente === undefined || info.Agente === "" ? {} : info.Agente,
      // PlanningDate: "¿?",
      SpecialsInstructions: info.InstruccionesEspecificas,
      AdditionalsComments: info.Comentarios,
      UserCreateId: this.props._user,
      totalweights: info.totalweights,
      lineCarge: info.lineCarge,
      TypeOrder: info.TypeOrder,
      Oslist: info.osLis,
      PoPurchaselist: info.poPurchaselist,
      DL: info.DL === undefined ? {} : info.DL,
      OKAM: info.OKAM === undefined ? {} : info.OKAM,
      FreightTermCode: info.FreightTermCode?.key,
      ServiceLevel: info.ServiceLevel?.key,
    };
    // console.log("data", data);
    await axios
      .post(`${Services.PLANTRANSPORT.path}plantrasp/savetp`, data)
      .then((response) => {
        this.setState({
          loadingInfo: false,
          modalAlert: true,
          typeAlert: "success",
          messageAlert: (
            <>
              {status === 2 ? (
                response.data.errorAsociacion ? (
                  <>
                    {this.props.t("asociation_message_error")}: <br />
                    {response.data.data}!
                  </>
                ) : (
                  <>
                    {this.props.t("successfully_transport_plan")}: <br />
                    {response.data.data}!
                  </>
                )
              ) : (
                <>
                  {this.props.t("draft_saved_successfully")}: <br />
                  {response.data.data}!
                </>
              )}
            </>
          ),
        });

        // Swal.fire({
        //   icon: "success",
        //   confirmButtonColor: "#0561fc",
        //   confirmButtonText: "Ok",
        //   html: `<div class="text-center euro-title-form">
        //   ${status === 2
        //       ? response.data.errorAsociacion
        //         ? `${this.props.t("asociation_message_error")} : <br> ${response.data.data
        //         }!`
        //         : `${this.props.t("successfully_transport_plan")}
        //       : <br> ${response.data.data}!`
        //       : `${this.props.t("draft_saved_successfully")} : <br> ${response.data.data
        //       }!`
        //     }
        //   </div>`,
        //   customClass: {
        //     confirmButton: 'custom-width-btn swal'
        //   }
        // });
        // this.props.history.push("/transport-plans");
      })
      .catch((error) => {
        console.warn(error);

        this.setState({ loadingInfo: false }, () => {
          Swal.fire({
            text: this.props.t("error_on_update_tp"),
            confirmButtonColor: "#0561fc",
            confirmButtonText: "Ok",
            customClass: {
              confirmButton: "custom-width-btn swal",
            },
          });
        });
      });
  };

  panelChange = (id) => (evt, expanded) => {
    let { createFormsData } = this.state;
    createFormsData.map((form) => {
      if (form.id == id) {
        form.expanded = expanded;
      }
    });
    this.setState({ createFormsData });
  };

  onSelectLeft = (selectedRowKeys, selectedRows) => {
    this.setState({
      leftSelectedKeys: selectedRowKeys,
      leftSelectedRows: selectedRows,
    });
  };

  onSelectRight = (selectedRowKeys, selectedRows) => {
    this.setState({
      rightSelectedKeys: selectedRowKeys,
      rightSelectedRows: selectedRows,
    });
  };

  addPOPurchaseOrdeAvaiable = () => {
    const { leftSelectedRows, leftSelectedKeys, posPO, poPurchaseOrderADD } =
      this.state;

    if (!leftSelectedKeys.length) return;

    const newLeft = posPO.filter(
      (item) => !leftSelectedKeys.includes(item.POItemsId),
    );

    const newRight = [...poPurchaseOrderADD, ...leftSelectedRows];

    this.setState({
      posPO: newLeft,
      poPurchaseOrderADD: newRight,
      leftSelectedKeys: [],
      leftSelectedRows: [],
      leftSearch: "",
    });
  };

  removePOPurchaseOrdeAvaiable = () => {
    const { rightSelectedRows, rightSelectedKeys, posPO, poPurchaseOrderADD } =
      this.state;

    if (!rightSelectedKeys.length) return;

    const newRight = poPurchaseOrderADD.filter(
      (item) => !rightSelectedKeys.includes(item.POItemsId),
    );

    const newLeft = [...posPO, ...rightSelectedRows];

    this.setState({
      posPO: newLeft,
      poPurchaseOrderADD: newRight,
      rightSelectedKeys: [],
      rightSelectedRows: [],
      rightSearch: "",
    });
  };

  addVisibility = () => {
    const { leftSelectedKeys, leftSelectedRows, posList, addConsolPlan } =
      this.state;

    if (!leftSelectedKeys.length) return;

    const newLeft = posList.filter(
      (item) => !leftSelectedKeys.includes(item.ServiceOrderId),
    );

    const newRight = [...addConsolPlan, ...leftSelectedRows];

    this.setState({
      posList: newLeft,
      addConsolPlan: newRight,
      leftSelectedKeys: [],
      leftSelectedRows: [],
      leftSearch: "",
    });
  };

  removeVisibility = () => {
    const { rightSelectedKeys, rightSelectedRows, posList, addConsolPlan } =
      this.state;

    if (!rightSelectedKeys.length) return;

    const newRight = addConsolPlan.filter(
      (item) => !rightSelectedKeys.includes(item.ServiceOrderId),
    );

    const newLeft = [...posList, ...rightSelectedRows];

    this.setState({
      posList: newLeft,
      addConsolPlan: newRight,
      rightSelectedKeys: [],
      rightSelectedRows: [],
      rightSearch: "",
    });
  };

  filterByFields = (item, search, fields) => {
    const text = search.toUpperCase();

    return fields.some((field) => {
      const value = item[field];

      if (!value) return false;

      return value.toString().toUpperCase().includes(text);
    });
  };

  //save purchase order list
  handleSavePurchase = async () => {
    let { catalgoSearch, info, poPurchaseOrderADD } = this.state;
    let newcatalgoSearch = _.cloneDeep(catalgoSearch);

    //console.log("info[NameCustomers]", info["NameCustomers"]);

    if (info["NameCustomers"] === undefined) {
      this.cancelModal();
    } else {
      info["poPurchaselist"] = [...poPurchaseOrderADD];
      info.lineCarge = poPurchaseOrderADD.length;
      info.totalweights = 0;
      info.QTYConfirmated = 0;
      let InitnewCatDLOKAM = [];
      let initNewCatServiceLevel = [];
      let transportModeSelected = info["TrasportMode"]
        ? info["TrasportMode"].key
        : undefined;

      let {
        validateNewCatTransportModes,
        newCatTransportModes,
        newcatSentby,
        newCatDLOKAM,
      } = await this.validateOwner(
        info.NameCustomers.OwnerTeam,
        transportModeSelected,
      );
      InitnewCatDLOKAM = newCatDLOKAM;
      let catalogoTrasportModeFinal = validateNewCatTransportModes
        ? newCatTransportModes
        : undefined;

      poPurchaseOrderADD.forEach((e, index) => {
        info.QTYConfirmated = info.QTYConfirmated + Number(e.QTYOrdered);
        info.totalweights = info.totalweights + Number(e.GrossWeight);
      });

      if (info["TrasportMode"]) {
        //console.log("info", info);
        let catalogNuevo = [];
        let uniqueCatalog = [];

        if (
          info["TrasportMode"] !== undefined &&
          info["ServiceType"] !== undefined
        ) {
          catalogNuevo = newcatalgoSearch[0]["ServiceTypeList"].filter(
            (e) =>
              e.TransportModeId === info["TrasportMode"].key &&
              e.SystemId === info["SistemaEp"].key &&
              e.ServiceTypeId === info["ServiceType"].key,
          );
          uniqueCatalog = Array.from(
            new Map(catalogNuevo.map((item) => [item.key, item])).values(),
          );
        }

        if (info["ShipmentsType"] && info["ShipmentsType"].key) {
          initNewCatServiceLevel = newcatalgoSearch[0]["ServiceLevel"].filter(
            (e) =>
              e.TransportModeId === info["TrasportMode"].key && // Corregido el error tipográfico
              e.ServiceTypeId === info["ServiceType"].key &&
              e.CatShipmentTypeId === info["ShipmentsType"].key,
          );
        }

        let serviceTypeCat = newcatalgoSearch[0]["CatServiceTypes"].filter(
          (e) =>
            e[info["TrasportMode"].text] === "1" &&
            e.SystemId === info["SistemaEp"].key,
        );

        this.setState(
          {
            info,
            visible: false,
            rightSelectedKeys: [],
            leftSelectedKeys: [],
          },
          () => {
            openNotification("success", this.props.t("correctly_updated"));
            this.renderForm(
              false,
              uniqueCatalog,
              true,
              serviceTypeCat,
              catalogoTrasportModeFinal,
              newcatSentby,
              InitnewCatDLOKAM,
              initNewCatServiceLevel,
            );
          },
        );
      } else {
        //console.log("info else", info);
        if (
          typeof info["NameCustomers"] !== "undefined" &&
          typeof info["NameCustomers"] === "object"
        ) {
          //console.log("info if 2", info);

          let {
            validateNewCatTransportModes,
            newCatTransportModes,
            newcatSentby,
            newCatDLOKAM,
          } = await this.validateOwner(
            info.NameCustomers.OwnerTeam,
            transportModeSelected,
          );
          InitnewCatDLOKAM = newCatDLOKAM;
          let catalogoTrasportModeFinal = validateNewCatTransportModes
            ? newCatTransportModes
            : undefined;
          this.setState(
            {
              info,
              visible: false,
            },
            () => {
              openNotification("success", this.props.t("correctly_updated"));
              this.renderForm(
                false,
                [],
                undefined,
                [],
                catalogoTrasportModeFinal,
                newcatSentby,
                InitnewCatDLOKAM,
                initNewCatServiceLevel,
              );
            },
          );
        } else {
          this.setState(
            {
              rightSelectedKeys: [],
              leftSelectedKeys: [],
              info,
              visible: false,
            },
            () => {
              openNotification("success", this.props.t("correctly_updated"));
              this.renderForm(
                false,
                [],
                undefined,
                [],
                [],
                [],
                InitnewCatDLOKAM,
                [],
              );
            },
          );
        }
      }
    }
  };

  render() {
    let {
      loadingInfo,
      visible,
      leftSelectedKeys,
      rightSelectedKeys,
      poActive,
      isMovil,
      rightSearch,
      poPurchaseOrderADD,
      leftSearch,
      posPO,
      buttonCheckValidateActive,
      modalAlert,
      typeAlert,
      messageAlert,
      posList,
      columns,
      addConsolPlan,
    } = this.state;

    const leftSource = poActive ? posPO : posList;
    const rightSource = poActive ? poPurchaseOrderADD : addConsolPlan;

    const fieldsToUse = poActive ? poFields : visibilityFields;

    const filteredLeftData = leftSource.filter((item) =>
      leftSearch ? this.filterByFields(item, leftSearch, fieldsToUse) : true,
    );

    const filteredRightData = rightSource.filter((item) =>
      rightSearch ? this.filterByFields(item, rightSearch, fieldsToUse) : true,
    );

    return loadingInfo ? (
      <Loader />
    ) : (
      <ContainerWrapper>
        <div id="loader" style={{ display: "block" }}>
          <div className="content-heading">
            <span className="icon-transport-plans icon-header" />
            {this.props.t("transports_plans")}
            <div className="euro-return-tittle">
              <Icon.Group size="large">
                <Icon
                  name="angle left"
                  className="_btnBack"
                  size="big"
                  onClick={() => this.props.history.push("/transport-plans")}
                />
              </Icon.Group>
              <span
                className="label-back"
                onClick={() => this.props.history.push("/transport-plans")}
              >
                {this.props.t("back")}
              </span>
            </div>
          </div>

          {this.state.createFormsData
            ? this.state.createFormsData.map((form) => {
                return (
                  <Card className="myCard">
                    <ExpansionPanel
                      defaultExpanded
                      onChange={this.panelChange(form.id)}
                    >
                      <ExpansionPanelSummary
                        expandIcon={
                          form.expanded ? (
                            <ExpandLess style={{ marginRight: "1em" }} />
                          ) : (
                            <ExpandMore style={{ marginRight: "1em" }} />
                          )
                        }
                      >
                        {form.img ? (
                          <img
                            style={{ margin: "6px", marginTop: "-1px" }}
                            alt=""
                            src={form.img}
                            height="35"
                            width="35"
                          ></img>
                        ) : (
                          " "
                        )}
                        <span className="euro-title-form" id={form.id}>
                          {this.props.t(form.titulo)}
                        </span>
                      </ExpansionPanelSummary>
                      <ExpansionPanelDetails>
                        <div className="col-12">
                          {<div className="row">{form.form}</div>}
                        </div>
                      </ExpansionPanelDetails>
                    </ExpansionPanel>
                  </Card>
                );
              })
            : false}
          {!this.state.isMovil ? (
            <div className="col-md-12 divcenter row">
              <div
                style={{ textAlign: "center" }}
                className="col-md-4 col-sm-4 col-4 col-lg-3 col-xl-2  divcenter"
              >
                <Button
                  block
                  color="secondary"
                  onClick={() => this.props.history.push("/transport-plans")}
                >
                  {this.props.t("cancel")}
                </Button>
              </div>
              <div
                style={{ textAlign: "center" }}
                className="col-md-4 col-sm-4 col-4 col-lg-3 col-xl-2  divcenter"
              >
                <Button
                  block
                  color="primary"
                  onClick={() =>
                    buttonCheckValidateActive ? this.validateTransPlan(1) : ""
                  }
                >
                  {this.props.t("save_draft")}
                </Button>
              </div>
              <div
                style={{ textAlign: "center" }}
                className="col-md-4 col-sm-4 col-4 col-lg-3 col-xl-2  "
              >
                <Button
                  block
                  color="primary"
                  onClick={() =>
                    buttonCheckValidateActive ? this.validateTransPlan(2) : ""
                  }
                >
                  {this.props.t("create_transport_plan")}
                </Button>
              </div>
            </div>
          ) : (
            <Row>
              <Col xs={1} md={12} lg={1} className="ml-auto mr-auto"></Col>
              <Col xs={12} md={4} lg={3} className="ml-auto mr-auto m-1">
                <Button
                  block
                  color="secondary"
                  onClick={() => this.props.history.push("/transport-plans")}
                >
                  {this.props.t("cancel")}
                </Button>
              </Col>
              <Col xs={12} md={4} lg={3} className="ml-auto mr-auto m-1">
                <Button
                  block
                  color="primary"
                  onClick={() =>
                    buttonCheckValidateActive ? this.validateTransPlan(1) : ""
                  }
                >
                  {this.props.t("save_draft")}
                </Button>
              </Col>
              <Col xs={12} md={4} lg={3} className="ml-auto mr-auto m-1">
                <Button
                  block
                  color="primary"
                  onClick={() =>
                    buttonCheckValidateActive ? this.validateTransPlan(2) : ""
                  }
                >
                  {this.props.t("create_transport_plan")}
                </Button>
              </Col>
              <Col xs={1} md={12} lg={1} className="ml-auto mr-auto"></Col>
            </Row>
          )}
        </div>
        <div id="loaderActive" style={{ display: "none" }}>
          <Loader />
        </div>
        <Modal
          title=""
          centered
          visible={visible}
          bodyStyle={{ height: "38 em" }}
          closable={false}
          width={1250}
          footer={null}
        >
          <div className="modal-transfer-header">
            <h4 className="modal-transfer-title">
              {poActive
                ? this.props.t("purchase_order")
                : this.props.t("request")}
            </h4>
            <div className="modal-transfer-divider" />
          </div>

          {poActive ? (
            <>
              <div className="row" style={{ marginBottom: "5em" }}>
                <div className="col-md-5">
                  {/* Título */}
                  <div style={{ marginBottom: "1em" }}>
                    <span className="euro-title-form">
                      {this.props.t("purchase_orders_available")}
                    </span>
                  </div>
                  {/* Search */}
                  <div className="spaceDivSearch">
                    <InputGroup>
                      <Input
                        placeholder={this.props.t("search_order_item")}
                        onChange={(e) =>
                          this.setState({ leftSearch: e.target.value })
                        }
                        value={leftSearch}
                      />
                    </InputGroup>
                  </div>
                  {/* Tabla */}
                  <div className="transfer-count">
                    {filteredLeftData.length} {this.props.t("request_lowcap")}
                  </div>
                  <TableCheckComponent
                    rowKey="POItemsId"
                    preserveSelectedRowKeys
                    pagination={false}
                    dataSource={filteredLeftData}
                    columns={this.state.columnAnt}
                    scroll={
                      filteredLeftData.length > 0
                        ? scrollTableFilter
                        : { x: 800 }
                    }
                    rowSelection={{
                      selectedRowKeys: leftSelectedKeys,
                      type: "checkbox",
                      onChange: this.onSelectLeft,
                      getCheckboxProps: (record) => ({
                        disabled:
                          record.name === "Disabled User" ||
                          !record.QTYConfirmed,
                        POItemsId: record.POItemsId,
                      }),
                    }}
                  />

                  {/* Mensaje */}
                  <p className="disabled-message">
                    {this.props.t("disabled-message-transport-plan-check")}
                  </p>
                </div>

                <div className="col-md-2 d-flex align-items-center justify-content-center">
                  <div className="w-100 text-center">
                    <Button
                      color="primary"
                      className="custom-width-btn mb-3"
                      onClick={this.addPOPurchaseOrdeAvaiable}
                    >
                      {this.props.t("add")}
                    </Button>

                    <Button
                      color="secondary"
                      className="custom-width-btn"
                      onClick={this.removePOPurchaseOrdeAvaiable}
                    >
                      {this.props.t("eliminate")}
                    </Button>
                  </div>
                </div>

                <div className="col-md-5">
                  {/* Título */}
                  <div style={{ marginBottom: "1em" }}>
                    <span className="euro-title-form">
                      {this.props.t("purchase_orders_add")}
                    </span>
                  </div>
                  {/* Search */}
                  <div className="spaceDivSearch">
                    <InputGroup>
                      <Input
                        placeholder={this.props.t("search_order_item")}
                        onChange={(e) =>
                          this.setState({ rightSearch: e.target.value })
                        }
                        value={rightSearch}
                      />
                    </InputGroup>
                  </div>
                  <div className="transfer-count">
                    {filteredRightData.length} {this.props.t("request_lowcap")}
                  </div>
                  {/* Tabla */}
                  <TableCheckComponent
                    rowKey="POItemsId"
                    preserveSelectedRowKeys
                    pagination={false}
                    dataSource={filteredRightData}
                    columns={this.state.columnAnt}
                    scroll={
                      filteredRightData.length > 0
                        ? scrollTableFilter
                        : { x: 800 }
                    }
                    rowSelection={{
                      selectedRowKeys: rightSelectedKeys,
                      type: "checkbox",
                      onChange: this.onSelectRight,
                      getCheckboxProps: (record) => ({
                        disabled: record.name === "Disabled User",
                        POItemsId: record.POItemsId,
                      }),
                    }}
                  />
                </div>
              </div>
            </>
          ) : (
            <div className="row" style={{ marginBottom: "5em" }}>
              <div className="col-md-5">
                {/* Título */}
                <div style={{ marginBottom: "1em" }}>
                  <span className="euro-title-form">
                    {this.props.t("orders_available")}
                  </span>
                </div>
                {/* Search */}
                <div className="spaceDivSearch">
                  <InputGroup>
                    <Input
                      placeholder={this.props.t("search_order")}
                      onChange={(e) =>
                        this.setState({ leftSearch: e.target.value })
                      }
                      value={leftSearch}
                    />
                  </InputGroup>
                </div>
                <div className="transfer-count">
                  {filteredLeftData.length} {this.props.t("request_lowcap")}
                </div>
                <TableCheckComponent
                  rowKey="ServiceOrderId"
                  dataSource={filteredLeftData}
                  columns={columns}
                  preserveSelectedRowKeys
                  pagination={false}
                  scroll={
                    filteredLeftData.length > 0
                      ? scrollTableFilterPoVisibility
                      : { x: 600 }
                  }
                  rowSelection={{
                    selectedRowKeys: leftSelectedKeys,
                    type: "checkbox",
                    onChange: this.onSelectLeft,
                  }}
                />
              </div>
              {/* ACTIONS */}
              <div className="col-md-2 d-flex align-items-center justify-content-center">
                <div className="w-100 text-center">
                  <Button block color="primary" onClick={this.addVisibility}>
                    {this.props.t("add")}
                  </Button>
                  <Button
                    block
                    color="secondary"
                    onClick={this.removeVisibility}
                  >
                    {this.props.t("eliminate")}
                  </Button>
                </div>
              </div>

              {/* RIGHT */}
              <div className="col-md-5">
                {/* Título */}
                <div style={{ marginBottom: "1em" }}>
                  <span className="euro-title-form">
                    {this.props.t("added_orders")}
                  </span>
                </div>

                <div className="spaceDivSearch">
                  <InputGroup>
                    <Input
                      placeholder={this.props.t("search_order")}
                      onChange={(e) =>
                        this.setState({ rightSearch: e.target.value })
                      }
                      value={rightSearch}
                    />
                  </InputGroup>
                </div>
                <div className="transfer-count">
                  {filteredRightData.length} {this.props.t("request_lowcap")}
                </div>
                <TableCheckComponent
                  rowKey="ServiceOrderId"
                  dataSource={filteredRightData}
                  columns={columns}
                  preserveSelectedRowKeys
                  pagination={false}
                  scroll={
                    filteredRightData.length > 0
                      ? scrollTableFilterPoVisibility
                      : { x: 600 }
                  }
                  rowSelection={{
                    selectedRowKeys: rightSelectedKeys,
                    type: "checkbox",
                    onChange: this.onSelectRight,
                  }}
                />
              </div>
            </div>
          )}
          <div className="row d-flex justify-content-end">
            <div
              style={{ textAlign: "right" }}
              className="col-xs-12 col-md-4 col-lg-2 m-1"
            >
              <Button block color="secondary" onClick={this.cancelModal}>
                {this.props.t("cancel")}
              </Button>
            </div>
            <div className="col-xs-12 col-md-4 col-lg-2 m-1">
              <Button
                block
                color="primary"
                className="button "
                onClick={() =>
                  poActive ? this.handleSavePurchase() : this.handleSave()
                }
              >
                {this.props.t("confirm")}
              </Button>
            </div>
          </div>
        </Modal>

        {createModal({
          isModalOpen: modalAlert,
          titleModal: typeAlert !== "error" ? "Success" : "Error",
          type: typeAlert,
          component: (
            <>
              <div className="col-12" style={{ textAlign: "center" }}>
                <p>{messageAlert}</p>
              </div>
            </>
          ),
          buttons: [
            {
              text: this.props.t("Ok"),
              // onClick: () => this.setState({ modalAlert: false }),
              onClick: () => this.props.history.push("/transport-plans"),
              type: "primary",
            },
          ],
          onCancel: () => this.props.history.push("/transport-plans"),
        })}
      </ContainerWrapper>
    );
  }
}
export default withNamespaces()(withRouter(withStyles(useStyles)(createUsers)));
